/** Linear guided walkthrough for brand-new restaurants — richer UI than quick-start modules. */

export const ADVANCED_WELCOME_TOUR_ID = "advanced-walkthrough";

export const ADVANCED_WELCOME_TOUR_STEPS = [
  {
    id: "adv-dashboard",
    route: "/dashboard",
    target: '[data-tour="tour-page-dashboard"]',
    icon: "fa-chart-line",
    captureLabelKey: "advTourCaptureDashboard",
    titleKey: "advTourDashboardTitle",
    bodyKey: "advTourDashboardBody",
    placement: "bottom",
  },
  {
    id: "adv-profile-nav",
    route: "/dashboard",
    target: '[data-tour="tour-nav-restaurant-info"]',
    icon: "fa-store",
    captureLabelKey: "advTourCaptureProfileNav",
    titleKey: "advTourProfileNavTitle",
    bodyKey: "advTourProfileNavBody",
    placement: "right",
    expandMenuKey: "restaurant",
  },
  {
    id: "adv-profile-page",
    route: "/app-profile",
    target: '[data-tour="tour-page-profile"]',
    icon: "fa-id-card",
    captureLabelKey: "advTourCaptureProfilePage",
    titleKey: "advTourProfilePageTitle",
    bodyKey: "advTourProfilePageBody",
    placement: "bottom",
  },
  {
    id: "adv-start-now",
    route: "/dashboard",
    target: '[data-tour="tour-nav-start-now"]',
    icon: "fa-wand-magic-sparkles",
    captureLabelKey: "advTourCaptureStartNow",
    titleKey: "advTourStartNowTitle",
    bodyKey: "advTourStartNowBody",
    placement: "right",
  },
  {
    id: "adv-start-now-page",
    route: "/start-now",
    target: '[data-tour="tour-page-start-now"]',
    icon: "fa-rocket",
    captureLabelKey: "advTourCaptureStartNowPage",
    titleKey: "advTourStartNowPageTitle",
    bodyKey: "advTourStartNowPageBody",
    placement: "bottom",
  },
  {
    id: "adv-qr-nav",
    route: "/dashboard",
    target: '[data-tour="tour-nav-qrcode"]',
    icon: "fa-qrcode",
    captureLabelKey: "advTourCaptureQrNav",
    titleKey: "advTourQrNavTitle",
    bodyKey: "advTourQrNavBody",
    placement: "right",
    expandMenuKey: "restaurant",
  },
  {
    id: "adv-qr-page",
    route: "/app-qrcode",
    target: '[data-tour="tour-page-qrcode"]',
    icon: "fa-print",
    captureLabelKey: "advTourCaptureQrPage",
    titleKey: "advTourQrPageTitle",
    bodyKey: "advTourQrPageBody",
    placement: "bottom",
  },
  {
    id: "adv-kitchen-nav",
    route: "/dashboard",
    target: '[data-tour="tour-nav-kitchen"]',
    expandMenuKey: "kitchen",
    icon: "fa-utensils",
    captureLabelKey: "advTourCaptureKitchen",
    titleKey: "advTourKitchenNavTitle",
    bodyKey: "advTourKitchenNavBody",
    placement: "right",
  },
  {
    id: "adv-menu",
    route: "/menu",
    target: '[data-tour="tour-page-menus"]',
    icon: "fa-book-open",
    captureLabelKey: "advTourCaptureMenu",
    titleKey: "advTourMenuTitle",
    bodyKey: "advTourMenuBody",
    placement: "bottom",
  },
  {
    id: "adv-categories",
    route: "/categories",
    target: '[data-tour="tour-page-categories"]',
    icon: "fa-layer-group",
    captureLabelKey: "advTourCaptureCategories",
    titleKey: "advTourCategoriesTitle",
    bodyKey: "advTourCategoriesBody",
    placement: "bottom",
  },
  {
    id: "adv-products",
    route: "/products",
    target: '[data-tour="tour-page-products"]',
    icon: "fa-burger",
    captureLabelKey: "advTourCaptureProducts",
    titleKey: "advTourProductsTitle",
    bodyKey: "advTourProductsBody",
    placement: "bottom",
  },
  {
    id: "adv-setup-guide",
    route: "/dashboard",
    target: '[data-tour="tour-nav-setup-guide"]',
    icon: "fa-rocket",
    captureLabelKey: "advTourCaptureSetupGuide",
    titleKey: "advTourSetupGuideTitle",
    bodyKey: "advTourSetupGuideBody",
    placement: "left",
  },
  {
    id: "adv-finish",
    route: "/dashboard",
    target: null,
    centered: true,
    icon: "fa-circle-check",
    titleKey: "advTourFinishTitle",
    bodyKey: "advTourFinishBody",
  },
];

export function getAdvancedWelcomeStepByIndex(index) {
  return ADVANCED_WELCOME_TOUR_STEPS[index] || null;
}
